/** The clock face's arithmetic — pure, so the leaf only owns the interval. */

/** below this the face turns danger-red and shows tenths (UX spec §7) */
export const LOW_TIME_MS = 10000;

export const remainingMs = (
  baseMs: number,
  runningSince: number | null,
): number => {
  const elapsed = runningSince ? Date.now() - runningSince : 0;
  const left = (baseMs || 0) - elapsed;
  return left > 0 ? left : 0;
};

export const format = (ms: number): string => {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const ss = String(seconds).padStart(2, '0');
  if (ms > 0 && ms < LOW_TIME_MS) {
    const tenths = Math.floor((ms % 1000) / 100);
    return `${minutes}:${ss}.${tenths}`;
  }
  return `${minutes}:${ss}`;
};
